export default __webpack_public_path__ + "static/media/slack_icon.24e99b7c.svg";